document.addEventListener("DOMContentLoaded", () => {

    // Different types of animation
    const animationMap = {
        'rn-underline': 'underline',
        'rn-circle': 'circle',
        'rn-box': 'box',
        'rn-highlight': 'highlight'
    };

    Object.entries(animationMap).forEach(([className, type]) => {
        document.querySelectorAll(`.${className}`).forEach(el => {

            // Apply animation when it enters screen
            const observer = new IntersectionObserver((entries, observerInstance) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;

                    observerInstance.unobserve(entry.target);

                    // Add slight delay on animation
                    setTimeout(() => {

                        const style = getComputedStyle(el);
                        const strokeColor = style.getPropertyValue('--rn-stroke')?.trim() || '#000';

                        // Determine stroke width based on tag and screen width
                        const screenWidth = window.innerWidth;
                        let strokeWidth = 2; // default fallback

                        // Check if element is inside a heading
                        const heading = el.closest('h1,h2,h3,h4,h5,h6');
                        if (heading) {
                            strokeWidth = screenWidth > 768 ? 6 : 2;
                        } else if (el.closest('p')) {
                            strokeWidth = 2;
                        }

                        // Apply classname to targeted words & target color of svg path
                        const container = el.parentElement;
                        if (container && getComputedStyle(container).position === 'static') {
                            container.style.position = 'relative';
                        }

                        // Create the annotation
                        const annotation = RoughNotation.annotate(el, {
                            type,
                            strokeWidth,
                            iterations: 1,
                            animate: true,
                            multiline: true,
                            color: strokeColor,
                            className: `rn-${type}-svg ${type === 'underline' ? 'svg-underline' : ''}`
                        });

                        annotation.show();

                        // Apply stroke color to annotation wrapper and paths
                        const wrapper = annotation.element;
                        wrapper.classList.add(`rn-${type}-svg`);
                        wrapper.style.setProperty('--rn-stroke', strokeColor);

                        const svg = wrapper.querySelector('svg');
                        if (svg) {
                            svg.querySelectorAll('path').forEach(p => {
                                p.setAttribute('stroke', strokeColor);
                            });
                        }
                    }, 600);
                });
            }, { threshold: 0.3 });

            observer.observe(el);
        });
    });
});
